import { ErrorHandler } from '@angular/core';

import { ApiConfigParserService } from '../shared/services/api-config-parser.service';
import { ApiConfigurationDataService } from '../shared/services/api-configuration-data.service';
import { ConfigParserService } from '../shared/services/config-parser.service';
import { WindowService } from '../shared/services/window.service';
import { isAppShell } from './is-app-shell.utility';

/**
 * Overrides the ConfigParserService, only if in App Shell mode.
 */
export function configParserServiceFactory(apiConfigurationDataService: ApiConfigurationDataService, errorHandler: ErrorHandler) {
    return isAppShell() ? new ApiConfigParserService(apiConfigurationDataService, errorHandler) : new ConfigParserService(errorHandler);
}

/**
 * Blocks app from booting until we get the Shell and Config data resolved successfully.
 * This is required for the Config Parser service to synchronously load config objects from the response (similar to loading from the DOM)
 */
export function initializeAppShell(apiConfigurationDataService: ApiConfigurationDataService) {
    return isAppShell() ? () => apiConfigurationDataService.getShellAndConfigPromise() : () => Promise.resolve();
}

/**
 * The ApiConfigurationDataService is used only in AppShell mode. It's required to configure the ApiConfigParserService.
 */
export function configDataServiceFactory(windowService: WindowService) {
    return isAppShell() ? new ApiConfigurationDataService(windowService) : null;
}
